import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import CRUDPage from '../../components/admin/CRUDPage';
import { Tag } from 'lucide-react';

export default function TagsPage() {
  const fields = [
    { 
      key: 'name', 
      label: 'Tag Name', 
      type: 'text', 
      required: true,
      placeholder: 'Enter tag name'
    },
    { 
      key: 'description', 
      label: 'Description', 
      type: 'textarea', 
      required: false,
      placeholder: 'Enter tag description (optional)'
    },
  ];

  return (
    <AdminLayout>
      <div className="p-8">
        <CRUDPage
          title="Tags"
          apiEndpoint="tags"
          dataKey="tags"
          fields={fields}
          icon={Tag}
        />
      </div>
    </AdminLayout>
  );
}
